/**
 * 
 * @param {boolean} props.open - Informa se o olho ficará aberto ou fechado. 
 */
const Eye = (props) => {
    const { open } = props;

    return (
        open ? <i className="fa-duotone fa-eye"></i> :
            <i className="fa-duotone fa-eye-slash"></i>
    )
}

export default Eye;